
const validate = values => {

  const errors = {}

  return errors
}

export default validate;


// WEBPACK FOOTER //
// ./src/components/siteadmin/ReservationManagement/ModalForm/validate.js